var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-overlay",class:{'active' : _vm.visible}},[_c('h2',[_vm._v("More Infos")])])}
var staticRenderFns = []

export { render, staticRenderFns }